// FollowUpsShell — the Follow-ups page's own minimal chrome
// (docs/follow-ups-plan.md §3).
//
// The call list is open to every signed-in welcomehps.com address, while the
// builder may be admin-only (§5), so this page does NOT sit inside AppShell and
// carries no way back into it: it is the shared MinimalShell (the builder's
// 56px topbar, the page's name, who is signed in, Sign out). A login on the RRA
// roster also gets a link to the Accommodations console, the one other page it
// may use without the builder; everyone else sees the bare header.

import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { MinimalShell } from '@/components/MinimalShell';
import { minimalNavFor } from '@/components/RequireBuilder';

export function FollowUpsShell({ children }: { children: ReactNode }): React.JSX.Element {
  const { capabilities } = useAuth();
  return (
    <MinimalShell title="Follow-ups" nav={minimalNavFor(capabilities)}>
      {children}
    </MinimalShell>
  );
}
